import { CAL_SOFTWARE_MNG } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: CAL_SOFTWARE_MNG,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入软件名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['softwareName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'calSoftwareCreate'
      }
    ]
  },

  view: {
    columns: [
      {
        props: {
          label: '软件名称',
          prop: 'softwareName',
          sortField: 'softwareName'
        }
      },
      {
        props: {
          label: '软件类型',
          prop: 'softwareType',
          sortField: 'softwareType'
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '减少并发率',
          prop: 'reduceConcurrency',
          sortField: 'reduceConcurrency'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 350
        },
        dataType: 'date'
      }
    ]
  }
}
